import { lazy } from "react";

const FleetGuard_Dashboard = lazy(() => import("@/pages/FleetGuard/Dashboard/index"));
const FleetGuard_Fleets = lazy(() => import("@/pages/FleetGuard/Fleets/index"));
const FleetGuard_MyFleets = lazy(() => import("@/pages/FleetGuard/MyFleets/index"));
const FleetGuard_VehicleTracking = lazy(() => import("@/pages/FleetGuard/VehicleTracking/index"));

const FleetGuard_Transactions = lazy(() => import("@/pages/FleetGuard/Transactions/index"));

const FleetGuard_Settings = lazy(() => import("@/pages/FleetGuard/StaticData/index"));
// const FleetGuard_Settings_FleetTypes = lazy(() => import("@/pages/FleetGuard/StaticData/FleetTypes/index"));
const FleetGuard_Reports = lazy(() => import("@/pages/FleetGuard/Reports/index"));

const FleetGuard_Others_Dispatches = lazy(() => import("@/pages/FleetGuard/Others/Dispatches/index"));
const FleetGuard_Others_Disposals = lazy(() => import("@/pages/FleetGuard/Others/Disposals/index"));
const FleetGuard_Others_DriverAssignments = lazy(() => import("@/pages/FleetGuard/Others/DriverAssignments/index"));
const FleetGuard_Others_FuelRefills = lazy(() => import("@/pages/FleetGuard/Others/FuelRefills/index"));
const FleetGuard_Others_Incidents = lazy(() => import("@/pages/FleetGuard/Others/Incidents/index"));
const FleetGuard_Others_Inspections = lazy(() => import("@/pages/FleetGuard/Others/Inspections/index"));
const FleetGuard_Others_Maintenance = lazy(() => import("@/pages/FleetGuard/Others/Maintenance/index"));
const FleetGuard_Others_Repairs = lazy(() => import("@/pages/FleetGuard/Others/Repairs/index"));
const FleetGuard_Others_Returns = lazy(() => import("@/pages/FleetGuard/Others/Returns/index"));
const FleetGuard_Others_Transfers = lazy(() => import("@/pages/FleetGuard/Others/Transfers/index"));

export var fleetGuardRoutes = [
    { path: "/fleetguard/dashboard", component: <FleetGuard_Dashboard /> },
    { path: "/fleetguard/fleets", component: <FleetGuard_Fleets /> },
    { path: "/fleetguard/my-fleets", component: <FleetGuard_MyFleets /> },
    { path: "/fleetguard/vehicle-tracking", component: <FleetGuard_VehicleTracking /> },

    { path: "/fleetguard/transactions", component: <FleetGuard_Transactions />, permissionTypeId: [] },

    { path: "/fleetguard/settings", component: <FleetGuard_Settings />, permissionTypeId: [] },
    { path: "/fleetguard/reports", component: <FleetGuard_Reports />, permissionTypeId: [] },

    { path: "/fleetguard/others/dispatches", component: <FleetGuard_Others_Dispatches />, permissionTypeId: [] },
    { path: "/fleetguard/others/disposals", component: <FleetGuard_Others_Disposals />, permissionTypeId: [] },
    { path: "/fleetguard/others/driver-assignments", component: <FleetGuard_Others_DriverAssignments />, permissionTypeId: [] },
    { path: "/fleetguard/others/fuel-refills", component: <FleetGuard_Others_FuelRefills />, permissionTypeId: [] },
    { path: "/fleetguard/others/incidents", component: <FleetGuard_Others_Incidents />, permissionTypeId: [] },
    { path: "/fleetguard/others/inspections", component: <FleetGuard_Others_Inspections />, permissionTypeId: [] },
    { path: "/fleetguard/others/maintenance", component: <FleetGuard_Others_Maintenance />, permissionTypeId: [] },
    { path: "/fleetguard/others/repairs", component: <FleetGuard_Others_Repairs />, permissionTypeId: [] },
    { path: "/fleetguard/others/returns", component: <FleetGuard_Others_Returns />, permissionTypeId: [] },
    { path: "/fleetguard/others/transfers", component: <FleetGuard_Others_Transfers />, permissionTypeId: [] },

];